import script from "./Poster.vue?vue&type=script&setup=true&lang=js"
export * from "./Poster.vue?vue&type=script&setup=true&lang=js"

import "./Poster.vue?vue&type=style&index=0&id=0a07506c&lang=less"

const __exports__ = script;

export default __exports__